export type UserStatus =
  | 'FIRST_TIME_LOGIN'
  | 'SIGNED_UP'
  | 'INCOMPLETE_ENROLLMENT'
  | 'ENROLLMENT_COMPLETE_NO_PAYMENT'
  | 'WAITLIST_ELIGIBILITY_REVIEW'
  | 'NO_MESSAGES_REMAINING'
  | 'PAYMENT_ISSUE'
  | 'FULLY_ENROLLED_ACTIVE'
  | 'PENDING_MATCHING'
  | 'ADDITIONAL_INFORMATION'
  | 'COMMUNITY_MEMBER';

export const USER_ROUTES: Record<UserStatus, string> = {
  FIRST_TIME_LOGIN: '/enrollment-welcome',
  SIGNED_UP: '/enrollment-welcome',
  ENROLLMENT_COMPLETE_NO_PAYMENT: '/application-received',
  WAITLIST_ELIGIBILITY_REVIEW: '/application-received',
  NO_MESSAGES_REMAINING: '/subscriptions',
  PAYMENT_ISSUE: '/subscriptions',
  FULLY_ENROLLED_ACTIVE: '/home',
  PENDING_MATCHING: '/application-received',
  ADDITIONAL_INFORMATION: '/addition-information',
  INCOMPLETE_ENROLLMENT: '/enrollment',
  COMMUNITY_MEMBER: '/enrollment-welcome',
};

export const STATUS_PRIORITY: UserStatus[] = [
  'PAYMENT_ISSUE',
  'NO_MESSAGES_REMAINING',
  'WAITLIST_ELIGIBILITY_REVIEW',
  'ENROLLMENT_COMPLETE_NO_PAYMENT',
  'INCOMPLETE_ENROLLMENT',
  'SIGNED_UP',
  'FIRST_TIME_LOGIN',
  'FULLY_ENROLLED_ACTIVE',
];

export const BYPASS_REDIRECT_PATHS = [
  '/subscriptions',
  '/checkout',
  '/success',
  '/addition-information',
  '/account-settings',
  '/billing',
  '/support',
  '/application-received',
];
